"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperUnitInformation = exports.WrapperHeader = exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1klhvwo2"
} : {
  target: "e1klhvwo2",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "xivppr",
  styles: "display:grid;grid-template-columns:80px 1fr 1fr;grid-column-gap:25px;margin:0 20px;padding:25px 0;border-bottom:1px solid #cfd9ea"
} : {
  name: "xivppr",
  styles: "display:grid;grid-template-columns:80px 1fr 1fr;grid-column-gap:25px;margin:0 20px;padding:25px 0;border-bottom:1px solid #cfd9ea",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const WrapperHeader = exports.WrapperHeader = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1klhvwo1"
} : {
  target: "e1klhvwo1",
  label: "WrapperHeader"
})(process.env.NODE_ENV === "production" ? {
  name: "1m6hzcc",
  styles: "display:flex;justify-content:center;align-items:center;height:93px;margin:-30px -20px;margin-bottom:0;&>span{display:inline-block;height:100%;width:100%;}"
} : {
  name: "1m6hzcc",
  styles: "display:flex;justify-content:center;align-items:center;height:93px;margin:-30px -20px;margin-bottom:0;&>span{display:inline-block;height:100%;width:100%;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const WrapperUnitInformation = exports.WrapperUnitInformation = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1klhvwo0"
} : {
  target: "e1klhvwo0",
  label: "WrapperUnitInformation"
})(process.env.NODE_ENV === "production" ? {
  name: "xavwhl",
  styles: "padding-top:2em;padding-bottom:1.4em"
} : {
  name: "xavwhl",
  styles: "padding-top:2em;padding-bottom:1.4em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});